<div class="modal-login">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form class="needs-validation" [formGroup]="form" (ngSubmit)="login()">
        <div class="modal-header border-bottom-0">
          <h5 class="modal-title text-center w-100">
            @if (global.isWhiteLabelVsvw) {
              <img src="../../assets/img/logo-vsvw.png" class="w-50 mt-3" alt="main_logo" />
            }
            @else {
              <img src="../../assets/img/logo-assist.svg" class="w-50 mt-3" alt="main_logo" />
            }
          </h5>
        </div>
        <ng-container *ngIf="step == 1">
          <div class="modal-body pt-2 pb-3">
            <div class="text-center mb-4">
              @if (global.isWhiteLabelVsvw) {
                <h5>Aanmelden bij VSVw</h5>
              }
              @else {
                <h5>Aanmelden in Assist</h5>
              }
            </div>
            <app-horizontal-text-input
              [control]="form.Username"
              [label]="'E-mailadres'"
            ></app-horizontal-text-input>
            <app-horizontal-text-input
              [control]="form.Password"
              [label]="'Wachtwoord'"
              [type]="'password'"
            ></app-horizontal-text-input>
            <div class="text-end">
              <a href="https://app.assistonline.eu/recover.aspx" target="_blank"
                >Wachtwoord vergeten?</a
              >
            </div>
            <div *ngIf="mustUseMicrosoftLogin" class="alert alert-info" role="alert">
              Je account is gekoppeld aan een Microsoft-account. Meld je aan met je
              Microsoft-account.
            </div>
            <div *ngIf="failed" class="alert alert-danger" role="alert">
              Je e-mailadres en/of wachtwoord is niet correct. Klik
              <a
                href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                target="_blank"
                >hier</a
              >
              voor hulp bij aanmelden.
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-center">
              <p>
                <app-button
                  [typeAction]="'submit'"
                  [isSaving]="isLoading"
                  [iconClass]="'fa-arrow-right-to-bracket'"
                  [name]="'Aanmelden'"
                ></app-button>
              </p>
              @if (!global.isWhiteLabelVsvw) {
                <p class="mb-1">of</p>
                <a href="{{ microsoftLoginUrl }}" style="text-decoration: none">
                  <app-microsoft-button [label]="'Aanmelden met Microsoft'"></app-microsoft-button>
                </a>
              }
              <p class="pt-4">
                <a
                  href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                  target="_blank"
                  >Hulp nodig bij aanmelden?</a
                >
              </p>
              @if (global.isWhiteLabelVsvw) {
                <p>
                  <a href="https://app.assistonline.eu/vrijwilligerswerk/" target="_blank"
                    >Nog geen account? Start hier.</a
                  >
                </p>
              }
              @else {
                <p>
                  <a href="https://app.assistonline.eu/" target="_blank"
                    >Nog geen account? Start hier.</a
                  >
                </p>
              }
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="step == 3">
          <div class="modal-body pt-2 pb-3">
            <div class="text-center mb-4">
              <h5>Aanmelden in Assist</h5>
            </div>
            <app-horizontal-text-input
              [id]="'Code'"
              [control]="form.Code"
              [label]="'Code'"
            ></app-horizontal-text-input>
            <app-radio
              [id]="'thrust'"
              [type]="'checkbox'"
              [control]="form.Thrust"
              [label]="'Vertrouw dit apparaat voor 30 dagen'"
            ></app-radio>

            <div *ngIf="failed" class="alert alert-danger" role="alert">
              Je e-mailadres en/of wachtwoord is niet correct. Klik
              <a
                href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                target="_blank"
                >hier</a
              >
              voor hulp bij aanmelden.
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-center">
              <p>
                <app-button
                  [typeAction]="'submit'"
                  [isSaving]="isLoading"
                  [iconClass]="'fa-arrow-right-to-bracket'"
                  [name]="'Aanmelden'"
                ></app-button>
              </p>
              <p class="pt-4">
                <a
                  href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                  target="_blank"
                  >Hulp nodig bij aanmelden?</a
                >
              </p>
              <p>
                <a href="https://app.assistonline.eu/" target="_blank"
                  >Nog geen account? Start hier.</a
                >
              </p>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="step === 4">
          <div class="modal-body pt-2 pb-3">
            <app-mfa-setup-step
              [login]="form.mapToModel()"
              [enforcingOrgName]="enforcingOrgName"
              (completed)="onMfaSetupCompleted($event)">
            </app-mfa-setup-step>
          </div>
        </ng-container>
        <ng-container *ngIf="step == 2">
          <div class="modal-body pt-2 pb-3">
            <div class="text-center mb-4">
              <h5>Aanmelden in Assist voor</h5>
            </div>
            <div class="text-center">
              <p *ngFor="let o of organizations; index as i">
                <app-button
                  (click)="loginAs(o)"
                  [isSaving]="o.isLoading"
                  [iconClass]="'fa-arrow-right-to-bracket'"
                  [name]="o.Organization.Name"
                ></app-button>
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-center">
              <p class="pt-4">
                <a
                  href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                  target="_blank"
                  >Hulp nodig bij aanmelden?</a
                >
              </p>
              <p>
                <a href="https://app.assistonline.eu/" target="_blank"
                  >Nog geen account? Start hier.</a
                >
              </p>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</div>
